var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-icon icon-egal-light",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 15.95h64v9.67H0v-9.67ZM0 39.16h64v9.672H0v-9.671Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }